//@ts-check
import validator from './validator';
/**@type {import("./types").FormFieldValidator} */

export default (function (value) {
  var error = validator.shouldBeSpecified(value, 'App category name');
  if (error) return error;
  error = validator.shouldHaveMaxLength(value, 256);
  if (error) return error;
  error = validator.shouldNotContainChars(value, validator.specialCharacters);
  if (error) return error;
  return undefined;
});